/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        key: "tips",
        value: "图片链接可以拖拽改变顺序",
        type: "tips"
    },
    {
        name: "轮播图",
        type: "module-name"
    },
    {
        key: "property_data",
        name: "属性",
        type: "custom",
        content: [{
                key: "height",
                name: "图片高度",
                type: "height"
            },
            {
                key: "padding",
                name: "图片边距",
                type: "text"
            },
            {
                key: "borderRadius",
                name: "图片圆角",
                type: "text"
            }
        ]
    },
    {
        key: "link_data",
        name: "链接",
        type: "img-link-list"
    }
];
export default config;